var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toolbar__icon"},[_c('svg-icon',_vm._b({},'svg-icon',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }